import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, HStack, Text, useBreakpointValue } from '@chakra-ui/react'
import { useEngine } from 'context'
import { ConfirmToPinParamList, GenericRouteParamList } from 'router/types'

export const Breadcrumbs = () => {
  const location = useLocation()
  const { pathname, state } = location
  const { engineState: { state: { engineBlocked } } } = useEngine()
  const breakpoint = useBreakpointValue({ base: 'small', md: 'desktop' })
  const [params, setParams] = useState<ConfirmToPinParamList | null>(null)

  const pathnames = pathname.split('/').filter(Boolean)

  const breadcrumbDictionary: { [id: string]: string } = {
    'my-vehicles': 'Mis Vehículos',
    'confirm-to-pin': params?.previousRoute === 'HOME' ? engineBlocked === null
      ? 'Sin información'
      : engineBlocked
        ? 'Desbloquear motor'
        : 'Bloquear motor'
      : 'Compartir vehículo',
    'owner-validation': 'Validación de documentos',
    'add-vehicle': 'Datos de vehículo',
    'hire-wicar': 'Suscripción premium',
    'subscription-info': 'Resumen de la suscripción',
    'contract-subscription': 'Activa la renovación automática',
    'payment-result/:plate/:isOnlyRenew/:appointment/:renewAutomatic/:result': 'Resultado de pago',
    'appointment': 'Solicitar agenda',
    'recover-vehicle': 'Recuperar vehículo',
    'reset-pin': 'Restablece tu PIN',
    'create-pin': 'Crea tu PIN',
    'billing': 'Datos de facturación',
    'detail-share-vehicle': 'Compartir vehículo',
    'add-contact-share-vehicle': 'Compartir vehículo',
    'request-permissions-share-vehicle': 'Compartir vehículo',
    'new-subscription': 'Contratar'
  }

  useEffect(() => {
    let params = null

    if (state) ({ params } = state as GenericRouteParamList<ConfirmToPinParamList>)
    params && setParams(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <HStack w={'100%'} justifyContent={'flex-start'}>
      <Breadcrumb>
        {pathnames.map((name, index) => {
          const isLast = index === pathnames.length - 1

          return (
            <BreadcrumbItem key={name} isCurrentPage={isLast}>
              <Text hidden={breakpoint === 'desktop'} px={2} variant={'SM'}>{'< '}</Text>
              <BreadcrumbLink as={Link} to={'/'}>
                <Text variant={'SM'}>Inicio</Text>
              </BreadcrumbLink>
              <Text hidden={breakpoint === 'small'} px={2} variant={'SM'}>{' > '}</Text>
              {isLast &&
                <Text hidden={breakpoint === 'small'} variant={'SM'}>{breadcrumbDictionary[name] || ''}</Text>
              }
            </BreadcrumbItem>
          )
        })}
      </Breadcrumb>
    </HStack>
  )
}
